<template>
  <h4 class="Title">
    <span class="index">{{ index + '.' }}</span> <slot />
  </h4>
</template>

<script>
export default {
  props: ['index'],
};
</script>

<style scoped>
.Title {
  position: relative;
  letter-spacing: 0px;
  color: #2b4047;
  font: normal normal bold 30px/40px Foco;
  width: 100%;
}
.Title::before {
  content: '';
  position: absolute;
  background: var(--qwellow);
  width: 40px;
  height: 40px;
  top: 0px;
  left: -5px;
  border-radius: 50%;
  z-index: -1;
}
.index {
  margin-right: 6px;
}
@media (min-width: 768px) {
  .Title {
    font: normal normal bold 70px/80px Foco;
    width: max-content;
  }
  .index {
    margin-right: unset;
  }
  .Title::before {
    width: 70px;
    height: 70px;
    top: 5px;
    left: -6px;
  }
}
</style>
